/* eslint-disable import/prefer-default-export */
import momentTZ from "moment-timezone";

const formatDatetime = ({
  datetimeStr,
  timezone,
  excludeTimezone,
}: {
  datetimeStr?: string;
  timezone?: string;
  excludeTimezone?: boolean;
}) => {
  if (!datetimeStr || !timezone) {
    return "-";
  }
  return momentTZ(datetimeStr)
    .tz(timezone)
    .format(excludeTimezone ? "DD MMM YYYY, HH:mm" : "DD MMM YYYY, HH:mm (UTC Z)");
};

export const formatScheduleTime = ({
  stop_after_datetime,
  stop_before_datetime,
  stop_time_type,
  stop_timezone,
  excludeTimezone = false,
  intl,
}: any) => {
  const afterText = intl.formatMessage({ id: "general.after", defaultMessage: "after" });
  const beforeText = intl.formatMessage({ id: "general.before", defaultMessage: "before" });
  const asapDeliveryText = intl.formatMessage({
    id: "new-request.schedule.defaultCargoReadyDeliveryOption.asap",
    defaultMessage: "ASAP delivery",
  });

  const afterDateTime = formatDatetime({ datetimeStr: stop_after_datetime, timezone: stop_timezone, excludeTimezone });
  const beforeDateTime = formatDatetime({ datetimeStr: stop_before_datetime, timezone: stop_timezone, excludeTimezone });

  const formattedDateTime = (
    <>
      {stop_time_type === "After" && (
        <span className="text-capitalize">
          {afterText} {afterDateTime}
        </span>
      )}
      {stop_time_type === "Before" && (
        <span className="text-capitalize">
          {beforeText} {beforeDateTime}
        </span>
      )}
      {stop_time_type === "Between" && (
        <span>
          {afterDateTime} - {beforeDateTime}
        </span>
      )}
      {stop_time_type === "ASAP" && <span>{asapDeliveryText}</span>}
    </>
  );

  return formattedDateTime;
};
